export default function IconMessagesBubbleSquareAdd({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g id="Messages-Bubble-Square-Add Streamline Ultimate" clipPath="url(#clip0_0_105)">
        <path
          id="Vector"
          d="M0.375 10.125C0.375 10.3239 0.454018 10.5147 0.59467 10.6553C0.735322 10.796 0.926088 10.875 1.125 10.875H3.375V13.875L6.375 10.875H15.375C15.5739 10.875 15.7647 10.796 15.9053 10.6553C16.046 10.5147 16.125 10.3239 16.125 10.125V1.125C16.125 0.926088 16.046 0.735322 15.9053 0.59467C15.7647 0.454018 15.5739 0.375 15.375 0.375H1.125C0.926088 0.375 0.735322 0.454018 0.59467 0.59467C0.454018 0.735322 0.375 0.926088 0.375 1.125V10.125Z"
          fill="#A7F3D0"
        />
        <path
          id="Vector_2"
          d="M1.125 10.875H3.375L13.875 0.375H1.125C0.926088 0.375 0.735322 0.454018 0.59467 0.59467C0.454018 0.735322 0.375 0.926088 0.375 1.125V10.125C0.375 10.3239 0.454018 10.5147 0.59467 10.6553C0.735322 10.796 0.926088 10.875 1.125 10.875Z"
          fill="#ECFDF5"
        />
        <path
          id="Vector_3"
          d="M8.625 13.125C8.625 14.3185 9.09911 15.4631 9.94302 16.307C10.7869 17.1509 11.9315 17.625 13.125 17.625C14.3185 17.625 15.4631 17.1509 16.307 16.307C17.1509 15.4631 17.625 14.3185 17.625 13.125C17.625 11.9315 17.1509 10.7869 16.307 9.94302C15.4631 9.09911 14.3185 8.625 13.125 8.625C11.9315 8.625 10.7869 9.09911 9.94302 9.94302C9.09911 10.7869 8.625 11.9315 8.625 13.125Z"
          fill="#A7F3D0"
        />
        <path
          id="Vector_4"
          d="M9.94313 16.3069C9.09915 15.4629 8.625 14.3182 8.625 13.1246C8.625 11.9311 9.09915 10.7864 9.94313 9.9424C10.7871 9.09841 11.9318 8.62427 13.1254 8.62427C14.319 8.62427 15.4636 9.09841 16.3076 9.9424L9.94313 16.3069Z"
          fill="#ECFDF5"
        />
        <path
          id="Vector_5"
          d="M8.625 13.125C8.625 14.3185 9.09911 15.4631 9.94302 16.307C10.7869 17.1509 11.9315 17.625 13.125 17.625C14.3185 17.625 15.4631 17.1509 16.307 16.307C17.1509 15.4631 17.625 14.3185 17.625 13.125C17.625 11.9315 17.1509 10.7869 16.307 9.94302C15.4631 9.09911 14.3185 8.625 13.125 8.625C11.9315 8.625 10.7869 9.09911 9.94302 9.94302C9.09911 10.7869 8.625 11.9315 8.625 13.125Z"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M13.125 10.875V15.375"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M15.375 13.125H10.875"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M7.125 10.875H6.375L3.375 13.875V10.875H1.125C0.926088 10.875 0.735322 10.796 0.59467 10.6553C0.454018 10.5147 0.375 10.3239 0.375 10.125V1.125C0.375 0.926088 0.454018 0.735322 0.59467 0.59467C0.735322 0.454018 0.926088 0.375 1.125 0.375H15.375C15.5739 0.375 15.7647 0.454018 15.9053 0.59467C16.046 0.735322 16.125 0.926088 16.125 1.125V7.125"
          stroke="#047857"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_105">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
